import { Typography } from '@mui/material';
import { useAppStatus } from 'features/appStatus/hooks/useAppStatus';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import React from 'react';

export const VersionInfo = () => {
  const { version } = useAppStatus();
  const { translation } = useTranslationContext();

  return (
    <Typography
      id="version-info"
      className="version-info"
      variant="body2"
      color="grey.700"
      align="center"
      height="14px"
    >
      {version ? `${translation('version')} ${version}` : ''}
    </Typography>
  );
};
